import React from "react";
import { markPageRefresh } from "./pageRefreshMarker";

function LazyWithRetry(factory: any, retries = 2) {
  return React.lazy(() =>
    new Promise((resolve, reject) => {
      const attempt = (retryCount: number) => {
        factory()
          .then(resolve)
          .catch((error: any) => {
            const isChunkError =
              /ChunkLoadError|Loading chunk [\d]+ failed/i.test(error?.message);

            if (isChunkError && retryCount > 0) {
              console.warn("Retrying dynamic import...", retryCount);
              attempt(retryCount - 1);
            } else if (isChunkError) {
              const hasReloaded = sessionStorage.getItem("chunk-reload");

              if (!hasReloaded) {
                sessionStorage.setItem("chunk-reload", "true");
                // Reloading to recover a failed chunk is a DOCUMENT refresh, not an app
                // close / open — device tracking must not report it as either.
                markPageRefresh();
                window.location.reload();
              }

              reject(error);
            } else {
              reject(error);
            }
          });
      };

      attempt(retries);
    })
  );
}

export default LazyWithRetry;